
  import { Component, Vue } from 'vue-property-decorator';
  import axios from 'axios';
  import { i18n } from '@/localizer';
  import settings from '../config';

  @Component({
    data() {
      return {
        FB: undefined,
      };
    },
    created() {
      const asyncLoadFb = (d: any, s: any, id: any) => {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        const js = d.createElement(s);
        js.id = id;
        js.src = `//connect.facebook.net/${i18n.locale}/sdk.js`;
        fjs.parentNode.insertBefore(js, fjs);
      };

      asyncLoadFb(document, 'script', 'facebook-jssdk');
    },
    mounted() {
      const appId = settings.VUE_APP_APP_ID;
      const version = settings.VUE_APP_API_VERSION;
      const vm = this as FacebookRelogin;

      if (this.$store.state.fbInitialized === false) {
        (window as any).fbAsyncInit = () => {
          FB.init({
            appId,
            cookie: true,
            xfbml: true,
            version,
          });

          FB.getLoginStatus((response) => {
            vm.statusChangeCallback(response);
            this.$store.commit('fbInitialized', true);
          });

          FB.Event.subscribe('auth.statusChange', vm.statusChangeCallback);
        };
      }
    },
  })
  export default class FacebookRelogin extends Vue {
    public scope = 'pages_manage_metadata, email, public_profile, business_management, ' + settings.VUE_APP_EXTRA_PERMISSIONS;
    public translationSection = settings.VUE_APP_TRANSLATION_SECTION;
    public loadingLogin = false;
    public posted = false;
    private errors: any[] = [];

    private getProfile() {
      FB.api('/me?fields=name,id,email,picture', (response: any) => {
        this.$store.commit('profile', response);
      });
    }

    private statusChangeCallback(response: IFacebookUserAuthenticate) {
      this.loadingLogin = true;

      if (response.status === 'connected' && response.authResponse) {
        if (!this.posted) {
          this.posted = true;
          axios.post((settings.VUE_APP_API_ADDRESS || settings.VUE_APP_BASE_URL) + 'activation/RefreshTokens',
          {
            token: response.authResponse.accessToken,
            appId: settings.VUE_APP_APP_ID,
          })
          .then((resp) => {
            this.getProfile();
            this.$store.commit('login', { status: true, accessToken: '' });
          })
          .catch((e) => {
            this.errors.push(e);
          })
          .finally(() => {
            this.loadingLogin = false;
          });
        }
      } else {
        this.$store.commit('login', { status: false, accessToken: '' });
        this.$store.commit('profile', {});
        this.loadingLogin = false;
        this.posted = false;
      }
    }
  }
